import { MD5 } from "crypto-js";
import { initializeApp } from "firebase/app";
import {
  Auth,
  getAuth,
  signInWithEmailAndPassword,
  UserCredential,
  // getIdToken
} from "firebase/auth";
import { SignInState } from "../app/shared/interfaces/components/signin.interface";

export const refreshToken = (): Auth => {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_PROJECT_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  };
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  // const token = getIdToken(auth.currentUser | {});
  return auth;
};

export const firebaseInitialize = (signinState: SignInState, tenantId: string): Auth => {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_PROJECT_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  };
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  if (tenantId) auth.tenantId = tenantId;
  return auth;
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_PROJECT_API_KEY,
  //apiKey: "AIzaSyA5K9U0fJ-DpmLc3tMARoyene8z3C-NNLw",
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth2 = getAuth(app);

export const firebaseSignIn = (
  auth: Auth,
  email: string,
  password: string
): Promise<UserCredential | void> => {
  const result = signInWithEmailAndPassword(
    auth,
    email.trim(),
    password.trim()
  );
  // Memorizza l'email nella sessione locale
  window.localStorage.setItem("userEmail", email);
  return result;
};

export const getAuthInstance = (): Auth => auth2;
